module.exports = {"TXTWCL_Events":{"id":"TXTWCL_Events","defaultMessage":"Événements"}}